import { render, staticRenderFns } from "./PermissionDetail.vue?vue&type=template&id=5abd86ed&scoped=true&"
import script from "./PermissionDetail.vue?vue&type=script&lang=js&"
export * from "./PermissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDetail.vue?vue&type=style&index=0&id=5abd86ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd86ed",
  null
  
)

export default component.exports